export const ACQUIRE_STATUS = {
  complete: 'complete',
  pending: 'pending',
  none: 'none',
};

export const OUT_OF_CREDITS_CODE = 405;
export const PRICING_295_UNLIMITED_OUT_OF_CREDITS_CODE = 409;
export const PRICING_295_BULK_PAGE_THROTTLING_CODE = 451;
export const BAD_REQUEST_CODE = 400;

export const CREDIT_SPLIT_ERRORS = {
  OUT_OF_CREDITS_ERROR_CODE: 405,
  CONTACT_NOT_FOUND_ERROR_CODE: 408,
};
export const DEFAULT_LIST_ID = 'all';

export const SHOW_INTERNAL_ERROR_TYPES = {
  CACHE_KEY_NOT_FOUND: 'CACHE_KEY_NOT_FOUND',
  MASKED_CONTACTS_NOT_FOUND: 'MASKED_CONTACTS_NOT_FOUND',
};

export const OUT_OF_CREDITS_BULK_ERROR_MESSAGE = 'Not enough resource to fulfill this operation';

export const OUT_OF_CREDITS_BULK_ERROR_OBJECT = {
  errorCode: OUT_OF_CREDITS_CODE,
  message: OUT_OF_CREDITS_BULK_ERROR_MESSAGE,
  data: {
    label: 'account',
    availableCredits: 0,
    type: 'credits',
  },
};
